import React, { useState } from 'react'
import { useWeb3React } from '@web3-react/core'
import { metaMask } from '../../connectors'
import ArrowIcon from '../../assets/arrow.svg'
import { DropdownMenu, DropdownMenuItem } from './DropdownMenu'
import { DepositModal } from './DepositModal'
import { WithdrawModal } from './WithdrawModal'
import Modal from 'react-modal'

Modal.setAppElement('#root')

export const HeaderDepositButton = () => {
  const { isActive } = useWeb3React()
  const [walletMenuOpened, setWalletMenuOpened] = useState(false)
  const [isMouseOnMenu, setIsMouseOnMenu] = useState(false)
  const [dropdownMenuSelected, setDropdownMenuSelected] = useState(
    DropdownMenuItem.NO_SELECTED
  )

  const [isOpen, setIsOpen] = useState(false)

  // The handler called when user try to close modal
  const onCloseModal = () => {
    setIsOpen(false)
  }

  return (
    <div className="w-32 h-8 rounded-xl border-2 border-white">
      <BaseDepositButton
        onClick={() => {
          setWalletMenuOpened(!walletMenuOpened)
        }}
        onMouseEnter={() => {
          setWalletMenuOpened(true)
        }}
        onMouseLeave={() => {
          setTimeout(() => {
            setWalletMenuOpened(false)
          }, 200)
        }}
      />

      {isActive ? (
        <>
          <DropdownMenu
            isShow={walletMenuOpened || isMouseOnMenu}
            onMouseEnter={() => {
              setIsMouseOnMenu(true)
            }}
            onMouseLeave={() => {
              setTimeout(() => {
                setIsMouseOnMenu(false)
              }, 200)
            }}
            onSelected={async (item: number) => {
              if (item === DropdownMenuItem.DISCONNECT) {
                console.log('close', 1)
                if (metaMask.deactivate) {
                  console.log('close', 2)
                  await metaMask.deactivate()
                }
                await metaMask.resetState()
                localStorage.removeItem('predy.connected')
                setWalletMenuOpened(false)
              } else {
                setDropdownMenuSelected(item)
                setIsOpen(true)
              }
            }}
          />
          <Modal
            isOpen={isOpen}
            onRequestClose={onCloseModal}
            shouldCloseOnOverlayClick={true}
            style={{
              overlay: {
                backgroundColor: '#ffffff70'
              },
              content: {
                borderWidth: 0,
                backgroundColor: '#1f2126',
                width: 380,
                height: 432,
                margin: 'auto',
                padding: 24
              }
            }}
          >
            {dropdownMenuSelected === DropdownMenuItem.DEPOSIT ? (
              <DepositModal onClose={onCloseModal} />
            ) : dropdownMenuSelected === DropdownMenuItem.WITHDRAW ? (
              <WithdrawModal onClose={onCloseModal} />
            ) : (
              <div />
            )}
          </Modal>
        </>
      ) : (
        <div />
      )}
    </div>
  )
}

const BaseDepositButton = ({
  onClick,
  onMouseEnter,
  onMouseLeave
}: {
  onClick?: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}) => {
  return (
    <>
      <div
        className="w-full h-full px-4 background-black text-sm text-white rounded-md flex flex-row items-center"
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div className="basis-5/6 my-auto">Deposit</div>
        <img className="basis-1/6 my-auto" src={ArrowIcon} />
      </div>
    </>
  )
}
